export const APP_SOUND_STORAGE_KEY = "app_sound";
export const APP_SOUND_CHANGE_EVENT = "app-sound-change";

export function isAppSoundEnabled() {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(APP_SOUND_STORAGE_KEY) !== "disabled";
  } catch (_) {
    return true;
  }
}

export function setAppSoundEnabled(enabled) {
  if (typeof window === "undefined") return Boolean(enabled);

  const nextEnabled = Boolean(enabled);

  try {
    window.localStorage.setItem(
      APP_SOUND_STORAGE_KEY,
      nextEnabled ? "enabled" : "disabled"
    );
  } catch (_) {}

  try {
    window.dispatchEvent(
      new CustomEvent(APP_SOUND_CHANGE_EVENT, {
        detail: { enabled: nextEnabled },
      })
    );
  } catch (_) {}

  return nextEnabled;
}

export function subscribeToAppSoundPreference(callback) {
  if (typeof window === "undefined" || typeof callback !== "function") {
    return () => {};
  }

  const emitCurrent = () => callback(isAppSoundEnabled());
  const emitCustom = (event) => {
    callback(
      typeof event?.detail?.enabled === "boolean"
        ? event.detail.enabled
        : isAppSoundEnabled()
    );
  };

  window.addEventListener(APP_SOUND_CHANGE_EVENT, emitCustom);
  window.addEventListener("storage", emitCurrent);
  window.addEventListener("focus", emitCurrent);
  document.addEventListener("visibilitychange", emitCurrent);

  return () => {
    window.removeEventListener(APP_SOUND_CHANGE_EVENT, emitCustom);
    window.removeEventListener("storage", emitCurrent);
    window.removeEventListener("focus", emitCurrent);
    document.removeEventListener("visibilitychange", emitCurrent);
  };
}
